import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Breadcrumbs from '../../components/ui/Breadcrumbs';
import Tabs from '../../components/ui/Tabs';
import { useAuth } from '../../context/AuthContext';
import ReportWorkspace from './components/ReportWorkspace';
import RunAuditTab from './components/RunAuditTab';
import { Fixed, PageWrap, StateBox } from './styles';

// PM analitik P7b — E16 Rapor Merkezi ve Denetim (/performance/report-center). İK kiracıyı, astı olan yönetici alt ağacını /
// ekibini görür; PM.Read tek başına yetki değildir (uçlar 403 döner). Denetim sekmesi yalnız İK. Var olan "Performans Raporları"
// sayfası yerinde kalır (rapor merkezi onun raporlarını yeniden kullanır; menü kararı entegrasyonda).
export default function PerformanceReportCenterPage() {
  const { t } = useTranslation();
  // İK rolü ayrımı — İK = sunucunun kararı (AuthContext.isHr), Şirket Yöneticisi DEĞİL.
  const { isHr, user } = useAuth();
  const canSee = isHr || Boolean(user?.hasSubordinates);
  const [tab, setTab] = useState('reports');
  const tabs = useMemo(() => [
    { key: 'reports', label: t('performance.reportCenter.tabs.reports') },
    { key: 'audit', label: t('performance.reportCenter.tabs.audit') },
  ], [t]);

  return (
    <PageWrap>
      <Fixed>
        <Breadcrumbs items={[{ label: t('performance.reportCenter.title') }]} />
        {isHr ? <Tabs tabs={tabs} activeTab={tab} onChange={setTab} /> : null}
      </Fixed>
      {!canSee ? <StateBox data-state="no-access">{t('performance.reportCenter.noAccess')}</StateBox> : null}
      {canSee && (tab === 'reports' || !isHr) ? <ReportWorkspace isHr={isHr} /> : null}
      {canSee && isHr && tab === 'audit' ? <RunAuditTab /> : null}
    </PageWrap>
  );
}
